<template>
	<div class="indexBlackes home-box" id="sw">
		<div class="swiper-container banner_wrap swiper-container-horizontal">
			<div class="swiper-wrapper">
				<div class="swiper-slide sliders" v-for="(item,index) in swiperImgs">
					<a href="">
						<img :src="item.cover" />
					</a>
				</div>
			</div>
			<div class="swiper-pagination swiper-pagination02"></div>
		</div>
		<!-- <div class="topusdt">
			<ul class="flex">
				<li v-for="(item,index) in quotation" v-if="item.is_display == 1&& index<6" :key="index">
					<div class="ft14" :data-name='item.currency_name+"/"+item.legal_name'>
						<div class="flex between">
							<div>
								<p>{{item.currency_name}}/{{item.legal_name}}</p>
								<p class="ft18 mt15 now_price mt">{{(item.now_price - 0).toFixed(4)}}</p>
							</div>
							<button
								:class="[{'downcolor': item.change.substring(0,1) == '-'}]">{{Number(item.change).toFixed(2)|| '0.00'}}%</button>
						</div>
						<p class="mt15 mt">
							<span class="color47">{{$t('home.vol')}}</span>
							<span class="volume">{{(item.volume-0).toFixed(2)}}</span>
						</p>
					</div>
				</li>
			</ul>
		</div> -->
		<div class="innewcontent">
			<div class="scroll-tempbox">
				<div class="scroll-temp">
					<div class="temp-box" ref="temp" v-if="quotation.length">
						<div v-for="(item,index) in quotation" :key="index + 'a'" class="li"
							v-if="item.is_display == 1&& index<6">
							<div class="ivu-row">
								<div class="ivu-col">
									<p class="font1">{{item.currency_name}}/{{item.legal_name}}</p>
									<p class="font2">{{(item.now_price - 0).toFixed(4)}}</p>
									<p class="font3">24H Vol {{item.volume}}</p>
								</div>
								<div class="align_right">
									<div class="font1" :class="[{'downcolor': item.change.substring(0,1) == '-'}]">
										{{Number(item.change).toFixed(2)|| '0.00'}}%
									</div>
									<div class="svg">
										<echarts :color="item.change.substring(0,1) == '-'?'#ef4034':'#57bda5'" :item="item.market_data.data" :idname="item.currency_name"></echarts>
									</div>
								</div>
							</div>
						</div>
						<div v-for="(item,index) in quotation" :key="index + 'b'" class="li"
							v-if="item.is_display == 1&& index<6">
							<div class="ivu-row">
								<div class="ivu-col">
									<p class="font1">{{item.currency_name}}/{{item.legal_name}}</p>
									<p class="font2">{{(item.now_price - 0).toFixed(4)}}</p>
									<p class="font3">24H Vol {{item.volume}}</p>
								</div>
								<div class="align_right">
									<div class="font1" :class="[{'downcolor': item.change.substring(0,1) == '-'}]">
										{{Number(item.change).toFixed(2)|| '0.00'}}%
									</div>
									<div class="svg">

										<echarts :color="item.change.substring(0,1) == '-'?'#ef4034':'#57bda5'" :item="item.market_data.data" :idname="item.currency_name+'1'">
										</echarts>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tableData" v-if="quotation.length">
				<p>{{$t('header.markets')}}</p>
				<div class="ivu-table-wrapper">
					<div class="ivu-table-header">
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('asset.currency')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('market.newprice')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('market.change')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('market.highprice')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('market.lowprice')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('lever.tdnum')}}</span>
							</div>
						</div>
						<div class="ivu-table-column-left">
							<div class="ivu-table-cell">
								<span>{{$t('sanqi.zhoushi')}} </span>
							</div>
						</div>
					</div>
					<div class="ivu-table-body">
						<div class="ivu-table-tbody">
							<div class="ivu-table-row" v-for="(item,index) in quotation" :key="index">
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<div>
											<img :src="item.logo">
											<span>{{item.currency_name}}/{{item.legal_name}}</span>
										</div>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span>{{(item.now_price - 0).toFixed(4)}}</span>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span>{{item.change}}%</span>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span>{{item.high}}</span>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span>{{item.low}}</span>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span>{{item.volume}}</span>
									</div>
								</div>
								<div class="ivu-table-column-left">
									<div class="ivu-table-cell">
										<span class="padingtop">
											<echarts :color="item.change.substring(0,1) == '-'?'#ef4034':'#57bda5'" :item="item.market_data.data" :idname="index"></echarts>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="productService">
				<div class="contentWidth">
					<h1 class="pagetitie">{{$t('sanqi.biaoti')}}</h1>
					<p class="pagetitie2">{{$t('sanqi.xiangqing')}}</p>
					<div class="productMain">
						<div class="ivu-row">
							<div class="ivu-col">
								<div class="ProductAndServeList">
									<img src="../assets/images/1639474720(1)_03.png">
									<h2>{{$t('sanqi.Global')}}</h2>
									<p>{{$t('sanqi.project')}}</p>
								</div>
							</div>
							<div class="ivu-col">
								<div class="ProductAndServeList">
									<img src="../assets/images/1639474720(1)_05.png">
									<h2>{{$t('sanqi.Bank')}}</h2>
									<p>{{$t('sanqi.level')}}</p>
								</div>
							</div>
							<div class="ivu-col">
								<div class="ProductAndServeList">
									<img src="../assets/images/1639474720(1)_07.png">
									<h2>{{$t('sanqi.Focus')}}</h2>
									<p>{{$t('sanqi.polish')}}</p>
								</div>
							</div>
							<div class="ivu-col">
								<div class="ProductAndServeList">
									<img src="../assets/images/1639474720(1)_09.png">
									<h2>{{$t('sanqi.Convenient')}}</h2>
									<p>{{$t('sanqi.Android')}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="downloadPage">
				<div class="downloadPage-right">
					<div class="download-con">
						<p class="downloadPage-right-title">{{$t('sanqi.Download')}}</p>
						<ul>
							<li>
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAADXUlEQVRoQ9WZa2jPURjHP88ml7nUxrRcR5YQyaUob1xeDClDGnJLTbkULxa5xtz3wsIUJbdckssi4gWv5FKUXNOWSUgzmyZ329Gj34+/v//vtmn/znm53znP+fyfPec5z/M9QhOHMaY/MAYYCvQFegAdgDTgE1AHvACeAneBayLyuCnbSmMWG2OygfnAbKBXI2xUAkeBgyLyPOr6SNDGmD7AWmAm0CLqZgnm/wCOA0UiUhHWXihoY0wrYDVQCLQOazzCvC9AMbBZRL4GrQuENsbkAKeAwUHG/sP3e8B0ESn3s+ULbYwZC5x1DtZ/YAplQg9unohc85rtCW2MyQNOABoazT00RGaIyLlEGyeEdjx8MUnALqeCT0jk8X+gnRi+08wh4fWf1FAZFh/jf0E7WeJW0KGrr2+geO9JSvadoaq6NnLodO6UzrKFUylclE9qakrQej2cI2KzSjz0RicP+xoqLj3JiqL9QZsFft++toDCxfmB85w8vs6d+BvauTgehMnDXQZN401VDTuLFpM3fhRIYOb8A2YM5y5dZ/m6UrI6Z/D6/ukw0JrHB7oXUCz0YWBOGAspWVpqwNvHZXTM0DIj2nhXU0dm/8m/FjW88cxs8UaPiMhc/eMvaKeW0IQe6mp2oauflJGRHh26praOTv0iQ+uVn6O1igu9AfgdM0F+SxK0Ym0UkfUu9LMo1VoSoStFpLc49fCjIO/Gfk8itGIMUOglwG6LoJcq9EFgnkXQhxT6BjDSIuibCv0S6GoR9CuF1qKkvUXQHxRak3aqRdD11nraypi2MntYmaetvBFVi7Or9nDqabuqPAfaynpaVVC7OhfH25F7xCi3qNfcRveIDrTKuKG6cbcJ8AJRaaBg9iR27DnB1l2q5HqPkNCJu3EHPJTu4Qfdvl0a78svICJ8/fadtJ652jh7UoeEVv36X93DgVaxMVBh8oNOSREqbh8ju3sW9x5WMGRcQVM97a8wOeCqR/tqeW2zc/n85ZsnTLcumeSOHs75Kzd9ZbM2rVvy8fllvx8VrOW5q4NU0y0lx1iz7UCTz+GmlQtYtWyWlx1VTSeKyNX4CY3Sp5tBgIyuT8d5PBkvAVMSedjlClQOrXtzifG4Xa9bsYfAqnfE+NNr1YttotyUjLfxnzbuFcPI7w1qAAAAAElFTkSuQmCC">
								<div class="conRight">
									<p class="conRight-title">{{$t('sanqi.Palm')}}</p>
									<p class="conRight-content">{{$t('sanqi.Trade')}}</p>
								</div>
							</li>
							<li>
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAADXUlEQVRoQ9WZa2jPURjHP88ml7nUxrRcR5YQyaUob1xeDClDGnJLTbkULxa5xtz3wsIUJbdckssi4gWv5FKUXNOWSUgzmyZ329Gj34+/v//vtmn/znm53znP+fyfPec5z/M9QhOHMaY/MAYYCvQFegAdgDTgE1AHvACeAneBayLyuCnbSmMWG2OygfnAbKBXI2xUAkeBgyLyPOr6SNDGmD7AWmAm0CLqZgnm/wCOA0UiUhHWXihoY0wrYDVQCLQOazzCvC9AMbBZRL4GrQuENsbkAKeAwUHG/sP3e8B0ESn3s+ULbYwZC5x1DtZ/YAplQg9unohc85rtCW2MyQNOABoazT00RGaIyLlEGyeEdjx8MUnALqeCT0jk8X+gnRi+08wh4fWf1FAZFh/jf0E7WeJW0KGrr2+geO9JSvadoaq6NnLodO6UzrKFUylclE9qakrQej2cI2KzSjz0RicP+xoqLj3JiqL9QZsFft++toDCxfmB85w8vs6d+BvauTgehMnDXQZN401VDTuLFpM3fhRIYOb8A2YM5y5dZ/m6UrI6Z/D6/ukw0JrHB7oXUCz0YWBOGAspWVpqwNvHZXTM0DIj2nhXU0dm/8m/FjW88cxs8UaPiMhc/eMvaKeW0IQe6mp2oauflJGRHh26praOTv0iQ+uVn6O1igu9AfgdM0F+SxK0Ym0UkfUu9LMo1VoSoStFpLc49fCjIO/Gfk8itGIMUOglwG6LoJcq9EFgnkXQhxT6BjDSIuibCv0S6GoR9CuF1qKkvUXQHxRak3aqRdD11nraypi2MntYmaetvBFVi7Or9nDqabuqPAfaynpaVVC7OhfH25F7xCi3qNfcRveIDrTKuKG6cbcJ8AJRaaBg9iR27DnB1l2q5HqPkNCJu3EHPJTu4Qfdvl0a78svICJ8/fadtJ652jh7UoeEVv36X93DgVaxMVBh8oNOSREqbh8ju3sW9x5WMGRcQVM97a8wOeCqR/tqeW2zc/n85ZsnTLcumeSOHs75Kzd9ZbM2rVvy8fllvx8VrOW5q4NU0y0lx1iz7UCTz+GmlQtYtWyWlx1VTSeKyNX4CY3Sp5tBgIyuT8d5PBkvAVMSedjlClQOrXtzifG4Xa9bsYfAqnfE+NNr1YttotyUjLfxnzbuFcPI7w1qAAAAAElFTkSuQmCC">
								<div class="conRight">
									<p class="conRight-title">{{$t('sanqi.flow')}}</p>
									<p class="conRight-content">{{$t('sanqi.Smooth')}}</p>
								</div>
							</li>
							<li>
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAADXUlEQVRoQ9WZa2jPURjHP88ml7nUxrRcR5YQyaUob1xeDClDGnJLTbkULxa5xtz3wsIUJbdckssi4gWv5FKUXNOWSUgzmyZ329Gj34+/v//vtmn/znm53znP+fyfPec5z/M9QhOHMaY/MAYYCvQFegAdgDTgE1AHvACeAneBayLyuCnbSmMWG2OygfnAbKBXI2xUAkeBgyLyPOr6SNDGmD7AWmAm0CLqZgnm/wCOA0UiUhHWXihoY0wrYDVQCLQOazzCvC9AMbBZRL4GrQuENsbkAKeAwUHG/sP3e8B0ESn3s+ULbYwZC5x1DtZ/YAplQg9unohc85rtCW2MyQNOABoazT00RGaIyLlEGyeEdjx8MUnALqeCT0jk8X+gnRi+08wh4fWf1FAZFh/jf0E7WeJW0KGrr2+geO9JSvadoaq6NnLodO6UzrKFUylclE9qakrQej2cI2KzSjz0RicP+xoqLj3JiqL9QZsFft++toDCxfmB85w8vs6d+BvauTgehMnDXQZN401VDTuLFpM3fhRIYOb8A2YM5y5dZ/m6UrI6Z/D6/ukw0JrHB7oXUCz0YWBOGAspWVpqwNvHZXTM0DIj2nhXU0dm/8m/FjW88cxs8UaPiMhc/eMvaKeW0IQe6mp2oauflJGRHh26praOTv0iQ+uVn6O1igu9AfgdM0F+SxK0Ym0UkfUu9LMo1VoSoStFpLc49fCjIO/Gfk8itGIMUOglwG6LoJcq9EFgnkXQhxT6BjDSIuibCv0S6GoR9CuF1qKkvUXQHxRak3aqRdD11nraypi2MntYmaetvBFVi7Or9nDqabuqPAfaynpaVVC7OhfH25F7xCi3qNfcRveIDrTKuKG6cbcJ8AJRaaBg9iR27DnB1l2q5HqPkNCJu3EHPJTu4Qfdvl0a78svICJ8/fadtJ652jh7UoeEVv36X93DgVaxMVBh8oNOSREqbh8ju3sW9x5WMGRcQVM97a8wOeCqR/tqeW2zc/n85ZsnTLcumeSOHs75Kzd9ZbM2rVvy8fllvx8VrOW5q4NU0y0lx1iz7UCTz+GmlQtYtWyWlx1VTSeKyNX4CY3Sp5tBgIyuT8d5PBkvAVMSedjlClQOrXtzifG4Xa9bsYfAqnfE+NNr1YttotyUjLfxnzbuFcPI7w1qAAAAAElFTkSuQmCC">
								<div class="conRight">
									<p class="conRight-title">{{$t('sanqi.Real')}}</p>
									<p class="conRight-content">{{$t('sanqi.time')}}</p>
								</div>
							</li>
							<li>
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAADXUlEQVRoQ9WZa2jPURjHP88ml7nUxrRcR5YQyaUob1xeDClDGnJLTbkULxa5xtz3wsIUJbdckssi4gWv5FKUXNOWSUgzmyZ329Gj34+/v//vtmn/znm53znP+fyfPec5z/M9QhOHMaY/MAYYCvQFegAdgDTgE1AHvACeAneBayLyuCnbSmMWG2OygfnAbKBXI2xUAkeBgyLyPOr6SNDGmD7AWmAm0CLqZgnm/wCOA0UiUhHWXihoY0wrYDVQCLQOazzCvC9AMbBZRL4GrQuENsbkAKeAwUHG/sP3e8B0ESn3s+ULbYwZC5x1DtZ/YAplQg9unohc85rtCW2MyQNOABoazT00RGaIyLlEGyeEdjx8MUnALqeCT0jk8X+gnRi+08wh4fWf1FAZFh/jf0E7WeJW0KGrr2+geO9JSvadoaq6NnLodO6UzrKFUylclE9qakrQej2cI2KzSjz0RicP+xoqLj3JiqL9QZsFft++toDCxfmB85w8vs6d+BvauTgehMnDXQZN401VDTuLFpM3fhRIYOb8A2YM5y5dZ/m6UrI6Z/D6/ukw0JrHB7oXUCz0YWBOGAspWVpqwNvHZXTM0DIj2nhXU0dm/8m/FjW88cxs8UaPiMhc/eMvaKeW0IQe6mp2oauflJGRHh26praOTv0iQ+uVn6O1igu9AfgdM0F+SxK0Ym0UkfUu9LMo1VoSoStFpLc49fCjIO/Gfk8itGIMUOglwG6LoJcq9EFgnkXQhxT6BjDSIuibCv0S6GoR9CuF1qKkvUXQHxRak3aqRdD11nraypi2MntYmaetvBFVi7Or9nDqabuqPAfaynpaVVC7OhfH25F7xCi3qNfcRveIDrTKuKG6cbcJ8AJRaaBg9iR27DnB1l2q5HqPkNCJu3EHPJTu4Qfdvl0a78svICJ8/fadtJ652jh7UoeEVv36X93DgVaxMVBh8oNOSREqbh8ju3sW9x5WMGRcQVM97a8wOeCqR/tqeW2zc/n85ZsnTLcumeSOHs75Kzd9ZbM2rVvy8fllvx8VrOW5q4NU0y0lx1iz7UCTz+GmlQtYtWyWlx1VTSeKyNX4CY3Sp5tBgIyuT8d5PBkvAVMSedjlClQOrXtzifG4Xa9bsYfAqnfE+NNr1YttotyUjLfxnzbuFcPI7w1qAAAAAElFTkSuQmCC">
								<div class="conRight">
									<p class="conRight-title">{{$t('sanqi.Rapid')}}</p>
									<p class="conRight-content">{{$t('sanqi.Experience')}}</p>
								</div>
							</li>
						</ul>
						<!-- <div class="btn">
							<div class="ivu-poptip">
								<div class="ivu-poptip-rel">
									<button type="button" class="apple ivu-btn ivu-btn-default ivu-btn-circle">
										<i class="ivu-icon ivu-icon-logo-apple"></i>
										<span>iPhone download</span>
									</button>
								</div>
							</div>
							<div class="ivu-poptip">
								<div class="ivu-poptip-rel">
									<button type="button" class="apple ivu-btn ivu-btn-default ivu-btn-circle android">
										<i class="ivu-icon ivu-icon-logo-apple"></i>
										<span>Android download</span>
									</button>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
			<div class="register">
				<p class="register-title">{{$t('sanqi.Join')}}</p>
				<p class="register-subTitle">{{$t('sanqi.Please')}}</p>
				<div class="account">
					<div>
						<input :placeholder="$t('sanqi.enter')" type="text" />
					</div>
					<button type="button">
						<span>{{$t('sanqi.Register')}}</span>
					</button>
				</div>
			</div>
		</div>
		<!-- <div class="notice_box">
			<div>
				<span v-for='(item,index) in noticeList' :key="index" @click="goDetail(item.id)">{{item.title}}</span>
			</div>
		</div> -->
		<!-- <div class="feature_wrap">
			<h2>{{$t('home.c01')}}</h2>
			<p>{{$t('home.c02')}}</p>
			<ul class="feature_list slide_ani a-fadeinB clearfix">
				<li class="feature_safe">
					<h3>{{$t('home.c03')}}</h3>
					<p>{{$t('home.c04')}}</p>
					<p>{{$t('home.c05')}}</p>
				</li>
				<li class="feature_eco">
					<h3>{{$t('home.c06')}}</h3>
					<p>{{$t('home.c07')}}</p>
					<p>{{$t('home.c08')}}</p>
				</li>
				<li class="feature_user">
					<h3>{{$t('home.c09')}}</h3>
					<p>{{$t('home.c10')}}</p>
					<p>{{$t('home.c11')}}</p>
				</li>
			</ul>
		</div> -->
		<!-- <div class="client_wrap">
			<div class="wrap_in tc">
				<img v-if="lang == 'zh'" src="../assets/images/iex/zh.jpg" >
				<img v-else-if="lang == 'en'" src="../assets/images/iex/en.jpg" >
				<img v-else-if="lang == 'kr'" src="../assets/images/iex/kr.jpg" >
				<img v-else-if="lang == 'jp'" src="../assets/images/iex/jp.jpg" >
				<img v-else-if="lang == 'ita'" src="../assets/images/iex/ita.jpg" >
				<img v-else-if="lang == 'hk'" src="../assets/images/iex/hk.jpg" >
				<img v-else-if="lang == 'fr'" src="../assets/images/iex/fr.jpg" >
				<img v-else-if="lang == 'es'" src="../assets/images/iex/es.jpg" >
				<img v-else-if="lang == 'de'" src="../assets/images/iex/de.jpg" >
				<h2 class="ft28">{{$t('home.c12')}}</h2>
				<p class="nextp">{{$t('home.c13')}}</p>
				<div class="flex" style="margin:70px 10% 0 10%">
					<ul class="">
						<li :class="lang == 'zh'?'indent':''" class="flex alcenter">
							<p class="p0"></p>
							<span>IPhone</span>
							<div class="codebox tc ft12">
								<img src="../assets/images/pcode.png" alt="">
								<span>Iphone</span>
							</div>
							{{$t('iesan.li_a')}}
						</li>
						<li :class="lang == 'zh'?'indent':''" class="flex alcenter">
							<p class="p1"></p>
							<span>{{$t('home.android')}}</span>
							<div class="codebox tc ft12">
								<img src="../assets/images/pcode.png" alt="">
								<span>{{$t('home.android')}}</span>
							</div>
							{{$t('iesan.li_b')}}
						</li>
						<li class="flex alcenter">
							<p class="p2"></p>
							<span>Windows</span>
						</li>
					</ul>
					<div class="mon_mind tc">
						<div>
							<img src="../../static/imgs/pcimg.png" class="pcimg" alt="">
						</div>
						<img src="../../static/imgs/mobimg.png" class="mobimg" alt="">
					</div>
				</div>
			</div>
		</div> -->
		<!-- <div class="register_wrap tc flex column center">
			<h2>{{$t('home.atrade')}}</h2>
			<div class="flex alcenter mauto rebox">
				<input type="text" class="input-register" :placeholder="$t('home.pinput')" v-model="haccount">
				<button class="ft16" @click="register">{{$t('lg.register')}}</button>
			</div>
		</div> -->
		<footer>
			<div class="content flex">
				<dl>
					<dt>
						<img src="@/assets/images/logo.png" alt=""
							style="margin-top:10px; height:60px;border-radius:8px;">
					</dt>
				</dl>
				<dl>
					<dt>{{$t('foo.about')}}</dt>
					<dd @click="Dgo(1,'qukuai')">{{$t('chongbi.qukuai')}}</dd>
					<dd @click="Dgo(2,'fabi')">{{$t('chongbi.fabi')}}</dd>
					<dd @click="Dgo(4,'gonggao')">{{$t('chongbi.gonggao')}}</dd>
					<dd @click="Dgo(6,'xitong')">{{$t('chongbi.xitong')}}</dd>
					<dd @click="Dgo(10,'yonghu')">{{$t('chongbi.yonghu')}}</dd>
					<dd @click="Dgo(11,'bangzhu')">{{$t('chongbi.bangzhu')}}</dd>
				</dl>
				<dl>
					<dt>{{$t('foo.support')}}</dt>
					<dd @click="Dgo(12,'shouyi')">{{$t('chongbi.shouyi')}}</dd>
					<dd @click="Dgo(13,'xinwen')">{{$t('chongbi.xinwen')}}</dd>
					<dd @click="Dgo(14,'xinshou')">{{$t('chongbi.xinshou')}}</dd>
					<dd @click="Dgo(16,'jiaoyi')">{{$t('chongbi.jiaoyi')}}</dd>
					<dd @click="Dgo(15,'kuaixun')">{{$t('chongbi.kuaixun')}}</dd>
				</dl>
				<dl class="tl">
					<dt>{{$t('foo.contact')}}</dt>
					<dd class="felx alcenter">
						<ul class="concat_ul flex tc end">
							<li class="wechat-box">
								<img @click="loca('https://wx.qq.com')" src="../assets/images/footer/wechat.png" alt="">
							</li>
							<li>
								<img @click="loca('https://www.facebook.com')"
									src="../assets/images/footer/facebook.png" alt="">
							</li>
							<li>
								<img @click="loca('https://twitter.com')" src="../assets/images/footer/twitter.png"
									alt="">
							</li>
							<li>
								<img @click="loca('https://www.youtube.com/')" src="../assets/images/footer/youtube.png"
									alt="">
							</li>
						</ul>
						<ul class="concat_ul flex tc mt10">
							<li>
								<img @click="loca('https://web.telegram.org/z/')"
									src="../assets/images/footer/telegram.png" alt="">
							</li>
							<li>
								<img @click="loca('https://www.instagram.com/')"
									src="../assets/images/footer/medium.png" alt="">
							</li>
							<li>
								<img @click="loca('https://login.yahoo.com/')" src="../assets/images/footer/ins.png"
									alt="">
							</li>
							<li>
								<img @click="loca('https://accounts.google.com/')"
									src="../assets/images/footer/email.png" alt="">
							</li>
						</ul>
					</dd>
				</dl>
			</div>
			<p class="flex column center mt20 tc ft12">
				<span class="white ft20">azbit</span>
				©Copyright 2019 azbit All rights reserved.
			</p>
		</footer>
	</div>
</template>


<script>
	let x = 0;
	// import "@/assets/style/iconfont2.css";
	// import "@/assets/style/iconfont.css";
	import "@/assets/style/index.css";
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	import indexHeader from "@/view/indexHeader";
	import echarts from '@/components/echarts'
	// var echarts = require("echarts");
	export default {
		name: "homeContent",
		components: {
			indexHeader,
			echarts
		},
		data() {
			return {
				tempInterval: undefined,
				list: [{
						id: 1,
						tit: this.$t('chongbi.qukuai'),
					},
					{
						id: 2,
						tit: this.$t('chongbi.fabi'),
					},
					{
						id: 4,
						tit: this.$t('chongbi.gonggao'),
					},
					{
						id: 6,
						tit: this.$t('chongbi.xitong'),
					},
					{
						id: 10,
						tit: this.$t('chongbi.yonghu'),
					},
					{
						id: 11,
						tit: this.$t('chongbi.bangzhu'),
					},
				],
				lister: [{
						id: 12,
						tit: this.$t('chongbi.shouyi'),
					},
					{
						id: 13,
						tit: this.$t('chongbi.xinwen'),
					},
					{
						id: 14,
						tit: this.$t('chongbi.xinshou'),
					},
					{
						id: 16,
						tit: this.$t('chongbi.jiaoyi'),
					},
					{
						id: 15,
						tit: this.$t('chongbi.kuaixun'),
					},
				],
				quotation: [],
				nowCoin: "",
				//   banner_imgs:[
				//       {href:'',img:'../assets/images/bg2.png'},
				//       {href:'',img:'../assets/images/bg2.png'},
				//       {href:'',img:'../assets/images/bg2.png'}
				//   ],
				curSwiper: 0,
				curCoinTab: 0,
				coinTabList: [{
					title: "USDT行情"
				}, {
					title: "BTC行情"
				}],
				coinKlineList: [],
				coinKline: {},
				swiperList: [],
				coinList: [],
				coin_list: [],
				noticeList: [],
				swiperImgs: [],
				footFrist: [],
				footSecond: [],
				haccount: '',
				datain: '',
				lang: '',
			};
		},
		created() {
			// this.init(this.initKline);
			this.getQuotation();
		},
		destroyed() {
			// window.removeEventListener('scroll', this.handleScroll)
			clearInterval(this.tempInterval);
		},
		mounted() {
			// window.addEventListener('scroll', this.handleScroll)
			this.tempInterval = setInterval(this.rollTemp, 50);
			this.getSwiper();
			this.connect();
			this.getNews();
			this.aboutUs();
			this.help();
			this.online();
			this.list = [{
					id: 1,
					tit: this.$t('chongbi.qukuai'),
				},
				{
					id: 2,
					tit: this.$t('chongbi.fabi'),
				},
				{
					id: 4,
					tit: this.$t('chongbi.gonggao'),
				},
				{
					id: 6,
					tit: this.$t('chongbi.xitong'),
				},
				{
					id: 10,
					tit: this.$t('chongbi.yonghu'),
				},
				{
					id: 11,
					tit: this.$t('chongbi.bangzhu'),
				},
			];
			this.lister = [{
					id: 12,
					tit: this.$t('chongbi.shouyi'),
				},
				{
					id: 13,
					tit: this.$t('chongbi.xinwen'),
				},
				{
					id: 14,
					tit: this.$t('chongbi.xinshou'),
				},
				{
					id: 16,
					tit: this.$t('chongbi.jiaoyi'),
				},
				{
					id: 15,
					tit: this.$t('chongbi.kuaixun'),
				},
			];
			this.lang = window.localStorage.getItem('locale');
		},
		methods: {
			rollTemp() {
				if (!this.quotation.length) {
					return
				}
				let all = 0;
				let count = this.$refs.temp.childElementCount;
				for (let i = 0; i < count; i++) {
					all += this.$refs.temp.children[i].offsetWidth;
				}
				let half = all >> 1;
				if (x < 1 - (half + (this.$refs.temp.children[0].offsetWidth * 0.41))) {
					x = 0;
				}
				x -= 2;
				this.$refs.temp.style.transform = "translateX(" + x + "px)";
			},
			loca(e) {
				window.location.href = e;
			},
			online() {
				// let _this = this;
				// this.$http({
				// 	url: '/api/news/online',
				// 	method: 'post',
				// 	data: {
				// 		// c_id: 19,
				// 		// lang: window.localStorage.getItem("locale")
				// 	},
				// }).then(res => {
				// 	console.log(res.data.message.service_url)
				// 	_this.datain = res.data.message.service_url
				// })
			},
			// handleScroll () {
			//   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			//   var top = $('.feature_list').offset().top

			//   console.log(top+'/'+scrollTop)
			// },
			linkDownload(url) {
				window.open(url, '_blank') // 新窗口打开外链接
			},
			register() {
				this.$router.push({
					name: 'register',
					query: {
						haccount: this.haccount
					}
				})
			},
			getSwiper() {
				this.$http({
						url: "/api/news/list",
						method: "post",
						data: {
							c_id: 17,
							lang: window.localStorage.getItem("locale")
						}
					})
					.then(res => {
						if (res.data.type == "ok") {
							this.swiperImgs = res.data.message.list;
						}
					})
					.then(() => {
						var mySwiper02 = new Swiper(".banner_wrap", {
							// direction: 'vertical',
							loop: true,
							autoplay: 5000,
							// 如果需要分页器
							pagination: ".swiper-pagination02",
							paginationClickable: true,
							autoplayDisableOnInteraction: false,
							observer: true, //修改swiper自己或子元素时，自动初始化swiper
							observeParents: true //修改swiper的父元素时，自动初始化swiper
						});
					});
			},
			connect() {
				var that = this;
				that.$socket.emit("login", localStorage.getItem("user_id"));
				that.$socket.on("daymarket", msg => {
					if (msg.type == 'daymarket') {
						for (var i = 0; i < this.quotation.length; i++) {
							if (this.quotation[i].legal_name == msg.legal_name && this.quotation[i]
								.currency_name == msg
								.currency_name) {
								this.quotation[i].now_price = msg.now_price;
								this.quotation[i].change = msg.change;
							}
						}
						var cname = msg.symbol;
						var change = msg.change;
						var now_price = msg.now_price;
						var volume = msg.volume;
						$("div[data-name='" + cname + "']")
							.find(".now_price")
							.html((now_price - 0).toFixed(4));
						$("div[data-name='" + cname + "']")
							.find(".volume")
							.html((volume - 0).toFixed(4));
						$("div[data-name='" + cname + "']")
							.find(".now_cny")
							.html((now_price * 6.9641).toFixed(4));

						$("div[data-name='" + cname + "']")
							.find("button")
							.text(change + '%');
						if (change < 0) {
							$("li[data-name='" + cname + "']")
								.find("button")
								.addClass('downcolor');
						} else {
							$("li[data-name='" + cname + "']")
								.find("button")
								.removeClass('downcolor')
						}

					}
				});
			},
			setPercent(a, b) {
				if (a - b == 0) {
					return "0%";
				} else if (a == 0) {
					return "-100%";
				} else if (b == 0) {
					return "+100%";
				} else {
					var p = ((a - b) / b / 100).toFixed(2);
					if (p > 0) {
						p = "+" + p + "%";
					} else {
						p = p + "%";
					}
					return p;
				}
			},
			getQuotation() {
				this.$http({
					url: "/api/currency/quotation_new",
					method: "get"
				}).then(res => {
					if (res.data.type == "ok" && res.data.message.length != 0) {
						// this.nowCoin = this.quotation[0].name;
						var data = res.data.message;
						this.quotation = data.find((item) => item.name == 'USDT').quotation;
					}
				});
			},
			getCurrent(index) {
				this.curCoinTab = index;
			},
			mouseEnter(index) {
				this.curSwiper = index;
			},
			init(callback) {
				this.$http.post("/api/" + "quotation").then(res => {
					if (res.data.type == "ok") {
						this.coinList = res.data.message.coin_list;
						this.swiperList = res.data.message.coin_list;
						callback && callback();
					} else {
						// layer.msg(res.message);
					}
				});
			},

			timestampToTime(timestamp) {
				var date = new Date(timestamp);
				let Y = date.getFullYear() + "/";
				let M =
					(date.getMonth() + 1 < 10 ?
						"0" + (date.getMonth() + 1) :
						date.getMonth() + 1) + "/";
				let D = date.getDate() + " ";
				return Y + M + D;
			},
			// 公告
			getNews() {
				var that = this;
				this.$http.post("/api/news/list", {
					"c_id": 4
				}).then(res => {
					if (res.data.type == "ok") {
						var list = res.data.message.list;
						that.noticeList = list;
					} else {}
				});
				// this.$http({
				//   url: "/api/news/list?c_id=5",
				//   type:'post'
				// }).then(res => {
				//   console.log(res);
				//   if (res.data.type == "ok") {
				//     var list = res.data.message.list;
				//     if (list.length > 2) {
				//       that.noticeList = list.slice(0, 2);
				//     } else {
				//       that.noticeList = list;
				//     }
				//   }
				// });
			},
			// 公告详情
			Dgo(id, tit) {
				var id = id;
				this.$router.push({
					name: "listnew",
					query: {
						id: id,
						tit: tit,
					}
				});
				// let routeUrl = this.$router.resolve({
				//   name: "noticeDetail",
				//   query: { id: id }
				// });
				// window.open(routeUrl .href, '_blank');
			},
			// 公告详情
			goDetail(id) {
				var id = id;
				this.$router.push({
					name: "noticeDetail",
					query: {
						id: id
					}
				});
				// let routeUrl = this.$router.resolve({
				//   name: "noticeDetail",
				//   query: { id: id }
				// });
				// window.open(routeUrl .href, '_blank');
			},
			aboutUs() {
				var that = this;
				this.$http.post("/api/news/list", {
					"c_id": 9
				}).then(res => {
					if (res.data.type == "ok") {
						var list = res.data.message.list;
						if (list.length > 2) {
							that.footFrist = list;
						} else {
							that.footFrist = list;
						}
					} else {
						// layer.msg(res.message);
					}
				});
			},
			help() {
				var that = this;
				this.$http.post("/api/news/list", {
					"c_id": 10
				}).then(res => {
					if (res.data.type == "ok") {
						var list = res.data.message.list;
						if (list.length > 2) {
							that.footSecond = list;
						} else {
							that.footSecond = list;
						}
					} else {
						// layer.msg(res.message);
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	.innewcontent {
		background-color: #FFFFFF;

		.scroll-tempbox {

			.scroll-temp {
				overflow: hidden;
				width: 1200px;
				margin: 0 auto;

				.temp-box {
					white-space: nowrap;
					margin-top: 74px;
					height: 107px;

					.li {
						display: inline-block;
						height: 100%;
						border: 1px solid #F2F2F2;
						display: inline-block;
						width: 283px;
						margin-right: 22px;
						padding: 10px;
						position: relative;
						cursor: pointer;

						.ivu-row {
							display: inline-block;
							position: relative;
							margin-left: 0;
							margin-right: 0;
							height: auto;
							zoom: 1;
							display: block;

							.ivu-col {
								display: block;
								float: left;
								width: 50%;

								.font1 {
									margin-bottom: 12px;
									line-height: 26px;
									font-family: helvetica;
									color: #000;
									font-size: 18px;
									font-weight: 700;
								}

								.font2 {
									margin-bottom: 5px;
									line-height: 26px;
									font-family: helvetica;
									color: #000;
									font-size: 18px;
									font-weight: 700;
								}

								.font3 {
									font-size: 12px;
									line-height: 14px;
									font-family: helvetica;
									color: #848e9c;
								}

								.downcolor {
									color: #ef4034;
								}
							}

							.align_right {
								display: block;
								float: left;
								width: 50%;

								.svg {
									width: 136px;
									height: 34px;
								}

								.font1 {
									line-height: 26px;
									font-family: helvetica;
									color: #000;
									font-size: 18px;
									margin-bottom: 12px;
									background-color: #57bda5;
									color: #fff;
									margin-left: 50%;
									padding: 0 10px;
									border-radius: 2px;
									font-size: 14px;
								}

								.downcolor {
									background-color: #ef4034;
								}
							}
						}
					}
				}
			}
		}


		.register {
			height: 266px;
			background: #fff;
			text-align: center;
			font-family: PingFangSC-Semibold, PingFang SC;

			.register-title {
				font-size: 36px;
				font-weight: 600;
				color: #212833;
				padding: 25px 0;
			}

			.register-subTitle {
				font-size: 14px;
				font-weight: 400;
				color: #707b8b;
				margin-bottom: 43px;
			}

			.account {
				div {
					width: 528px;
					margin-right: 10px;
					display: inline-block;
					position: relative;
					vertical-align: middle;
					line-height: normal;

					input {
						height: 51px;
						display: inline-block;
						width: 100%;
						line-height: 1.5;
						padding: 4px 7px;
						font-size: 12px;
						border: 1px solid #dcdee2;
						border-radius: 4px;
						color: #515a6e;
						background-color: #fff;
						background-image: none;
						position: relative;
						cursor: text;
						transition: border .2s ease-in-out, background .2s ease-in-out, box-shadow .2s ease-in-out;
					}
				}

				button {
					background-color: #f0b74c;
					border-color: #f0b74c;
					font-size: 16px;
					padding: 0;
					border-radius: 5px;
					width: 112px;
					height: 52px;
					color: #fff;

					span {}
				}
			}
		}

		.downloadPage {
			height: 670px;
			background: url(../assets/images/bgDownload.3e924f8c.png) no-repeat 50%;

			.downloadPage-right {
				width: 1200px;
				margin: 0 auto;

				.download-con {
					margin-left: 50%;

					.downloadPage-right-title {
						font-size: 36px;
						font-family: PingFangSC-Semibold, PingFang SC;
						font-weight: 600;
						color: #fff;
						line-height: 40px;
						padding: 110px 0 24px;
					}

					ul {
						height: 212px;

						li {
							width: 50%;
							margin-top: 50px;
							position: relative;
							float: left;

							img {
								float: left;
							}

							.conRight {
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #fff;
								padding-left: 56px;

								.conRight-title {
									font-size: 20px;
								}

								.conRight-content {
									font-size: 14px;
									color: hsla(0, 0%, 100%, .49);
								}
							}
						}
					}

					.btn {
						margin-top: 104px;

						.ivu-poptip {
							display: inline-block;

							.ivu-poptip-rel {
								position: relative;

								.android {
									border-radius: 32px;
									overflow: hidden;
									margin-left: 18px;
									background: #021640;
									color: #fff;

								}

								button {
									border-radius: 32px;
									overflow: hidden;
									height: 34px;
									width: 148px;
									border: 1px solid;

									/* .ivu-icon-logo-apple:before {
										content: "\F301";
										box-sizing: border-box;
									}

									.ivu-icon {
										font-size: 20px;
										vertical-align: middle;
										line-height: 1.5;
										display: inline-block;
										font-family: Ionicons;
										speak: none;
										font-style: normal;
										font-weight: 400;
										font-variant: normal;
										text-transform: none;
										text-rendering: auto;
									} */

									span {
										font-size: 14px;
										margin-left: 4px;
										vertical-align: middle;
									}
								}
							}
						}
					}
				}
			}
		}

		.productService {
			background: #f9fafe;

			.contentWidth {
				width: 1200px;
				margin: 0 auto;
				min-height: 660px;

				.pagetitie {
					padding-top: 120px;
					color: #212833;
					font-weight: 600;
					line-height: 26px;
					font-size: 36px;
					padding-bottom: 33px;
					text-align: center;
				}

				.pagetitie2 {
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #707b8b;
					line-height: 26px;
					text-align: center;
				}

				.productMain {
					padding: 93px 0 116px;

					.ivu-row {
						position: relative;
						margin-left: 0;
						margin-right: 0;
						height: auto;
						zoom: 1;
						display: block;
						margin-left: -25px;
						margin-right: -25px;
						display: flex;

						.ivu-col {
							padding-left: 25px;
							padding-right: 25px;
							display: block;
							width: 25%;

							.ProductAndServeList {
								text-align: center;

								img {
									width: 75px;
									height: 75px;
									display: block;
									margin: 0 auto;
								}

								h2 {
									font-size: 21px;
									color: #212833;
									margin: 22px 0 19px;
									font-weight: 500;
								}

								p {
									color: #707b8b;
									font-size: 14px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									line-height: 23px;
								}
							}
						}
					}
				}
			}
		}


		.tableData {
			width: 1200px;
			margin: 0 auto;
			background: #fff;
			padding-bottom: 95px;

			p {
				padding-top: 32px;
				font-size: 24px;
				font-family: Helvetica-Bold, Helvetica;
				font-weight: 700;
				color: #212833;
				line-height: 64px;
			}

			.ivu-table-wrapper {
				border: 0;
				border-top: 1px solid #e3ebf7;
				font-size: 16px;
				font-family: Helvetica;
				color: #000;
				line-height: 26px;

				.ivu-table-header {
					width: 1199px;
					display: flex;

					.ivu-table-column-left:nth-child(1) {
						flex: 1.4;
					}

					.ivu-table-column-left:last-child {
						text-align: center;
					}

					.ivu-table-column-left {
						height: 80px;
						border: 0;
						border-bottom: 1px solid #e3ebf7;
						background-color: #fff;
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #797979;
						line-height: 80px;
						text-align: left;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						vertical-align: middle;
						flex: 1;

						.ivu-table-cell {
							padding-left: 18px;
							padding-right: 18px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: normal;
							word-break: break-all;
							box-sizing: border-box;
							display: inline-block;
							word-wrap: normal;
							vertical-align: middle;
							align-items: center;
							display: flex;

							span {
								display: block;
								width: 100%;
							}
						}
					}
				}

				.ivu-table-body {
					width: 1199px;

					.ivu-table-tbody {
						.ivu-table-row {
							display: flex;

							.ivu-table-column-left:nth-child(1) {
								flex: 1.4;
							}

							.ivu-table-column-left:last-child {
								text-align: center;
							}

							.ivu-table-column-left {
								flex: 1;
								height: 80px;
								line-height: 80px;
								border: 0;
								border-bottom: 1px solid #e3ebf7;
								text-align: left;
								background-color: #fff;
								transition: background-color .2s ease-in-out;
								box-sizing: border-box;
								text-overflow: ellipsis;
								vertical-align: middle;
								min-width: 0;

								.ivu-table-cell {
									padding-left: 18px;
									padding-right: 18px;
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: normal;
									word-break: break-all;
									box-sizing: border-box;

									.padingtop {
										display: block;
										padding-top: 25px;
									}

									img {
										margin-right: 45px;
										display: inline-block;
										width: 22px;
										height: 22px;
										background-size: cover;
										position: relative;
										top: 4px;
									}

									span {}
								}
							}
						}
					}
				}
			}
		}
	}

	#text p {
		display: inline-block;
		border: none !important;
		color: #FFFFFF;
	}

	#sw {
		.topusdt {
			border-top: 1px solid rgba(29, 50, 66, .7);
			background-color: #0a151e;
			// background-color:#203f46;
			color: #9eb5ca;

			ul {
				width: 100%;

				li {
					width: 20%;
					padding: 14px 0;
					height: 120px;

					>div {
						border-right: 1px solid rgba(29, 50, 66, .7);
						padding: 0 40px;
					}

					.color47 {
						color: #477a90;
					}

					.ml5 {
						margin-left: 5px;
					}

					button {
						border: none;
						padding: 5px 20px;
						border-radius: 5px;
						height: 30px;
						background: #0d2f32;
						color: #0d8551;
					}

					.downcolor {
						color: #ef4034;
					}
				}

				li:last-child {
					>div {
						border-right-color: transparent;
					}
				}

				li:hover {
					background: #122331;

					>div {
						border-color: transparent;
					}
				}

			}
		}

		footer {
			width: 100%;
			// background: #111114;
			background: #000;
			padding: 50px 0 0 0;
			text-align: center;

			.content {
				width: 1200px;
				margin: 0 auto;
				justify-content: space-between;
				border-top: 1px solid #42f1eb;
				padding-top: 30px;

				dl {
					flex: 1;
					text-align: center;

					dt {
						font-size: 16px;
						color: #fff;
						margin-bottom: 10px;
					}

					dd {
						font-size: 14px;
						color: #a7b7c7;
						line-height: 24px;
						cursor: pointer;
						padding-top: 10px;

						&:hover {
							color: #fff;
						}
					}
				}
			}

			p {
				/* border-top: 1px solid #303035; */
				height: 35px;
				color: #727b92;
			}
		}

		.concat_ul {
			justify-content: flex-end;

			li {
				width: 32px;
				height: 32px;
				background: #303e63;
				border-radius: 50%;
				margin-right: 10px;

				img {
					width: 20px;
					height: 20px;
					margin-top: 6px;
				}
			}

			li:hover {
				background: #5697f4;
			}

			.wechat-box {
				position: relative;

				.weimg {
					width: 140px;
					height: 140px;
					position: absolute;
					top: -155px;
					left: -60px;
					border: 5px solid #fff;
					display: none;
				}
			}

			.wechat-box:hover .weimg {
				display: block;
			}
		}

		.md {
			width: 1500px;
			margin: 0 auto;

			>div:first-child {
				margin-top: 90px;
				text-align: center;
				font-size: 40px;
				color: #fff;

				>span:last-child {
					margin-left: 6px;
					color: #33fffb;
				}

				.btn {
					background: linear-gradient(90deg, #33fffb, #44c3d5);
					width: 268px;
					margin: 30px auto 0;
					text-align: center;
					line-height: 56px;
					border-radius: 30px;
					font-size: 18px;
					color: #fff;
				}

				img {
					display: block;
					margin: 0 auto;
					width: 1180px;
					height: 635px;
				}
			}

			>div:nth-child(2) {
				padding-top: 60px;
				background: url("../assets/images/zg.jpg") right top/ 832px 432px no-repeat;
				height: 500px;

				>div:first-child {
					font-size: 40px;
					font-weight: bold;
					color: #bec1da;
				}

				>div:nth-child(2) {
					margin-top: 20px;
					color: rgba(139, 137, 200, 0.5);
					line-height: 30px;
					width: 45%;
				}
			}
		}

		.news {
			margin-top: 100px;
			position: relative;

			>p {
				font-weight: 600;
				font-size: 20px;
				margin: 200px auto 100px;
				color: #fff;
				width: 1500px;
			}

			.line {
				position: absolute;
				width: 100%;
				height: 1px;
				background: rgba(255, 255, 255, 0.05);
				top: 105px;
				z-index: 9;
			}

			>.items {
				width: 1500px;

				margin: 0 auto;
				display: flex;
				justify-content: space-between;

				>.item {
					transition: all 0.3s;
					height: 330px;
					cursor: pointer;
					color: hsla(0, 0%, 100%, 0.9);
					border-radius: 4px;
					width: 33%;

					>.date {
						font-size: 24px;
						padding-bottom: 60px;
						color: #bec1da;
					}

					>p {
						color: #8b89c8;
					}

					.content {
						position: relative;
						transition: all 0.3s;
						max-width: 485px;
						height: 206px;
						padding: 30px;
						border-radius: 6px;
						background-color: rgba(24, 24, 76, 1);
						background-size: 100% !important;

						&::before {
							content: "";
							position: absolute;
							left: 50px;
							top: -10px;
							width: 0;
							border-right: 10px solid transparent;
							border-left: 10px solid transparent;
							border-bottom: 10px solid #2b2b6d;
							opacity: 0;
							-webkit-transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
							transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
						}

						img {
							position: absolute;
							border-radius: 6px;
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							opacity: 0;
							transition: all 0.5s;
							// z-index: -1;
						}

						.title {
							font-size: 16px;
							color: #bec1da;
							padding-bottom: 30px;
						}

						p {
							font-size: 14px;
							color: #8b89c8;
						}
					}

					>.title {
						font-size: 16px;
						color: #bec1da;
						// font-weight:
					}

					&:hover {
						transition: all 0.5s;

						.content {
							&::before {
								opacity: 1;
							}

							>p,
							>div {
								transform: translateY(16px);
								transition: all 0.5s;
							}

							img {
								transition: all 0.5s;
								opacity: 1;
							}

							// background: rgba(24, 24, 76, 0) url("../assets/images/homehov.jpg");
							// background-size: 100%;
						}
					}
				}

				>.item:nth-child(3) {
					opacity: 1;

					.content {
						&::before {
							opacity: 1;
						}

						div,
						p {
							position: relative;
							z-index: 99;
						}

						img {
							opacity: 1;
						}
					}
				}
			}
		}

		.notice {
			width: 1500px;
			margin: 0 auto;
			justify-content: space-between;

			>div {
				border-radius: 3px;
				font-size: 12px;
				padding: 30px;
				width: 360px;
				height: 360px;
				color: rgba(139, 137, 200, 0.5);
				background: linear-gradient(to bottom right, #2b2b6d, #18184c);
				cursor: pointer;
				box-shadow: none;
				transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

				>div:nth-child(2) {
					transition: all 0.3s;
				}

				div:nth-child(3) {
					padding-top: 10px;
				}

				&:hover {
					background: url("../assets/images/homehov.jpg") center center/ 100% 100% no-repeat;
					box-shadow: 0 0.05rem 0.45rem rgba(0, 0, 0, 0.2);
					transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
					color: #fff;

					>div:nth-child(2) {
						transform: translateY(-10px);
						transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
					}

					>div:nth-child(3) {
						border-top: 1px solid rgba(139, 137, 200, 0.5);
					}

					.notpic1 {
						background-image: url("../assets/images/hhov2.png") !important;
					}

					.notpic2 {
						background-image: url("../assets/images/hhov4.png") !important;
					}

					.notpic3 {
						background-image: url("../assets/images/hhov5.png") !important;
					}

					.notpic4 {
						background-image: url("../assets/images/hhov8.png") !important;
					}
				}

				>div:first-child {
					width: 80px;
					height: 88.8px;
					margin: 30px auto 0;
					margin-bottom: 20px;
					text-align: center;
				}

				>div:nth-child(2) {
					font-size: 18px;
					margin: 30px 0 20px;
					color: #bec1da;
				}

				>div:last-child {
					line-height: 24px;
				}
			}

			>div:first-child {
				>div:first-child {
					background: url("../assets/images/hhov1.png") center center/ 100% 100% no-repeat;
				}
			}

			>div:nth-child(2) {
				>div:first-child {
					background: url("../assets/images/hhov3.png") center center/ 100% 100% no-repeat;
				}
			}

			>div:nth-child(3) {
				>div:first-child {
					background: url("../assets/images/hhov6.png") center center/ 100% 100% no-repeat;
				}
			}

			>div:nth-child(4) {
				>div:first-child {
					background: url("../assets/images/hhov7.png") center center/ 100% 100% no-repeat;
				}
			}
		}

		.mb {
			position: relative;
			// margin-top: 100px;
			height: 800px;
			padding-left: 800px;

			img {
				position: absolute;
				left: -497px;
				top: 0;
				width: 1770px;
			}

			>div {
				display: flex;
				position: relative;
				z-index: 99;
				height: 800px;
				justify-content: center;
				flex-direction: column;

				>div {
					padding: 100px 0 30px;
					font-size: 36px;
					color: #33fffb;
				}

				p {
					line-height: 30px;
					color: rgba(139, 137, 200, 0.5);
				}
			}
		}

		.home-box {
			// background: rgb(24, 24, 76);
		}

		div.swiper-container .swiper-pagination {
			// left: initial;
			// right: 10px !important;
			// top: 0;
			// height: 100%;
			// width: 10px;
			// display: flex;
			// flex-direction: column;
			// justify-content: center;
		}

		div.swiper-container .swiper-pagination>span {
			// display: block;
			background: #fff;
			border-radius: 0;
			width: 56px;
			height: 3px;
			// opacity: 0.5;
			// margin: 10px 0;
		}

		div.swiper-container .swiper-pagination-bullet-active {
			background: transparent;
			border: 2px solid #fff;
		}

		.up-clr {
			color: #12b886;
		}

		.down-clr {
			color: #cc4951;
		}

		/* 币种列表 */
		.coins-list {
			margin: 10px auto;
			width: 1500px;
			line-height: 40px;
			text-align: center;

			// border: 1px solid #4e5b85;
			.coin-tab {
				height: 42px;
				color: #c7cce6;
				display: flex;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);

				>ul {
					display: flex;

					li {
						padding: 0 40px;
						font-size: 14px;
						// box-shadow: 0 0 1px hsla(231, 9%, 54%, 0.2);
						// border-bottom: 1px solid #4e5b85;
						// border-right: 1px solid #4e5b85;
					}

					.activeCoin {
						border-bottom: none;
					}
				}
			}

			.list-title {
				display: flex;

				>span {
					flex: 1;

					text-align: center;
					color: #8b89c8;
					font-size: 14px;
				}
			}

			.list-con {
				// background: rgb(32, 36, 55);
				max-height: 680px;
				overflow: auto;

				&::-webkit-scrollbar {
					display: none;
				}

				li:nth-child(2n) {
					background: rgb(24, 24, 76);
				}

				li:nth-child(2n + 1) {
					background: rgb(34, 31, 97);
				}

				li {
					display: flex;
					// border-bottom: 1px solid #282e44;
					color: #c7cce6;

					&:hover {
						background: rgb(22, 22, 68);
					}

					>div {
						flex: 1;
					}
				}
			}
		}

		.carousel .swiper-slide:hover {
			background-color: #327add;
		}

		.nav_left,
		.con_left {
			display: flex;
			align-items: center;
			justify-content: space-around;
		}

		.withdraw {
			margin: 0 4px;
		}

		.carousel .last a:hover {
			cursor: pointer;
		}

		.sliders {
			width: 100%;
			max-height: 540px;
			overflow: hidden;

			img {
				width: 100%;
				display: block;
			}

			@media screen and (max-width:1560px) {
				// height: 465px;
				// img{
				//   width: 100%;
				//   height: 465px;
				// }
			}
		}

		@media screen and (max-width:1410px) {
			// .mt{margin-top:5px;}
		}

		.swiper-container-horizontal>.swiper-pagination-bullets {
			bottom: 25px;
		}

		.swiper-pagination-bullet {
			width: 56px !important;
			height: 3px;
			border-radius: 0;
			background: #fff;
		}

		.notice_ul {
			margin: 0 40px;
			padding: 5px 0;
			// background: #171c2b;
			overflow: hidden;
			word-break: keep-all;
		}

		.notice_ul>li {
			// flex: 1;
			font-size: 12px;
			padding: 0 15px;
			text-align: center;
			color: #9eb5ca;
			word-break: keep-all;
			position: relative;
		}

		.notice_ul>li::after {
			content: "/";
			position: absolute;
			left: -0.5em;
			color: #9eb5ca;
		}

		.notice_ul>li:last-child:after {
			content: "";
			color: #6b80ae;
		}

		.notice_ul>li:hover {
			color: #6b80ae;
			cursor: pointer;
		}

		.feature_wrap {
			background-color: #fff;
			padding: 90px 0;
			text-align: center;
			color: #54748f;
			line-height: 2em;
		}

		.feature_wrap h2 {
			font-size: 28px;
			margin-bottom: 10px;
			color: #192544;
		}

		.feature_wrap .feature_list {
			padding-top: 80px;
			width: 70%;
			margin: 0 auto;
		}

		.feature_wrap .feature_list li {
			float: left;
			width: 33%;
			background: transparent none no-repeat top;
			// padding-top: 140px;
			padding-top: 70px;
		}

		.feature_wrap .feature_list li.feature_safe {
			// background-image: url(../../static/imgs/feature_safe.8e76904.svg);
			background-image: url(../../static/imgs/ppp0.svg)
		}

		.feature_wrap .feature_list li.feature_eco {
			// background-image: url(../../static/imgs/feature_eco.4f174e6.svg);
			background-image: url(../../static/imgs/ppp1.svg)
		}

		.feature_wrap .feature_list li.feature_user {
			// background-image: url(../../static/imgs/feature_user.7002f27.svg);
			background-image: url(../../static/imgs/ppp2.svg)
		}

		.feature_wrap h3 {
			font-size: 18px;
			font-weight: 700;
			margin-bottom: 10px;
			color: #192544;
		}

		.notice_box {
			width: 100%;
			height: 52px;
			border-top: 1px solid rgba(29, 50, 66, .7);
			margin-top: -1px;
			background-color: #f6f9fc;
			position: relative;

			>div {
				margin: 0 30px;
				font-size: 12px;
				line-height: 52px;
				height: 36px;
				overflow: hidden;
				word-break: keep-all;
				text-align: center;

				span {
					display: inline-block;
					position: relative;
					padding: 0 2em 0 1.5em;
					color: #54748f;
					cursor: pointer;
				}

				span:before {
					content: "/";
					position: absolute;
					left: -.5em;
					color: #54748f;
				}

				span:nth-child(1):before {
					content: "";
				}

				span:hover {
					color: #357ce1;
				}
			}
		}

		.client_wrap {
			width: 100%;
			/* height: 710px; */
			color: #9eb5ca;
			text-align: center;
			line-height: 2em;
			background-color: #fff;

			.wrap_in {
				/* height: 700px;
				padding-top: 100px;
				background-color: #152940; */
				background: url(../../static/imgs/blue.svg) no-repeat;
				background-size: cover;

				img {
					display: block;
					width: 100%;
					height: auto;
				}

				h2 {
					margin-bottom: 24px;
					color: #fff;
					font-weight: 400;
					font-size: 28px;
				}

				.nextp {
					color: #9eb5ca
				}

				ul {
					width: 810px;
					margin: 0 auto;
					text-align: left;
					justify-content: space-around;

					.indent {
						text-indent: 2em;
					}

					li {

						margin: 0 15px;
						color: #9eb5ca;
						/* padding: 40px 0; */
						line-height: 48px;
						position: relative;
						cursor: pointer;

						p {
							height: 48px;
							width: 48px;
							margin: 0 10px 0 0;
							vertical-align: top;
							border-radius: 50%;
							background: rgba(53, 124, 225, .1) none no-repeat 50%;
							background-image: url(../assets/images/p0.svg)
						}

						.p1 {
							background-image: url(../assets/images/p1.svg)
						}

						.p2 {
							background-image: url(../assets/images/p2.svg)
						}

						.codebox {
							position: absolute;
							left: 15%;
							top: 100px;
							-webkit-transform: translate(-50%);
							-ms-transform: translate(-50%);
							transform: translate(-50%);
							-webkit-box-sizing: border-box;
							box-sizing: border-box;
							width: 120px;
							height: 130px;
							border: 1px solid #357ce1;
							border-radius: 2px;
							background: #fff none no-repeat 12px 12px/96px 96px;
							text-align: center;
							color: #357ce1;
							font-size: 12px;
							line-height: 18px;
							z-index: 6;
							display: none;

							img {
								width: 100px;
								height: 100px;
								margin: 0 auto;
								display: block;
								margin-top: 10px;
							}
						}
					}

					li:hover .codebox {
						display: block;
					}
				}

				.mon_mind {
					width: 518px;
					position: relative;
					margin: 0 auto;

					>div {
						width: 100%;

						.pcimg {
							width: 518px;
							margin: 0 auto;
						}
					}

					.mobimg {
						width: 122px;
						position: absolute;
						right: -60px;
						bottom: -20px;
						width: 122px;
						height: 253px;
						background: #0a151e none no-repeat 50%/cover;
						-webkit-box-shadow: -9px 12px 62px 0 rgba(36, 52, 69, .3);
						box-shadow: -9px 12px 62px 0 rgba(36, 52, 69, .3);
						border-radius: 16.47px;
					}
				}
			}
		}

		.register_wrap {
			height: 240px;
			width: 100%;
			// border-top: 1px solid #cad7e0;
			background: #fff;

			h2 {
				color: #232a4a;
				font-size: 22px;
				line-height: 24px;
			}

			.rebox {
				margin: 32px auto 0 auto;
			}

			.input-register {
				width: 400px;
				height: 40px;
				font-size: 12px;
				color: #000;
				border: 1px solid #bdced9;
				border-radius: 2px;
				padding-left: 16px;
			}

			button {
				margin-left: 8px;
				display: inline-block;
				height: 40px;
				padding: 0 44px;
				font-size: 16px;
				min-width: 120px;
				-webkit-appearance: none;
				background-color: #357ce1;
				color: #fff;
				border: none;
				outline: none;
				border-radius: 2px;
				cursor: pointer;
			}

			button:hover {
				opacity: .8;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/homeContent.vue